const serverConfigs = require("../../config/config")

export default {
    login: "/login",
    // screeningLogin: "/casLogin",
    getUserByToken: "/fetchUserByToken",
    register: "/register",
    data: "/getPersonalData",
    update: "/updatePersonalData",
    reSubmit: "/reSubmit",
    uploadFile: "/uploadFile",
    uploadVideo: "/video/upload",
    deleteFile: "/deleteFile",
    public: serverConfigs().publicPath,
    resource: serverConfigs().resourcePath,
    video: serverConfigs().videoPath,
    videoDownload: serverConfigs().videoDownloadPath,
	startRegisteration: "/secondConfirm",
    confirmEmail: "/emailConfirmed",
    resetPassword: "/startResetPassword",
    updatePassword: "/updatePassword",
    checkResetToken: "/checkResetToken",
    logout: "/logout",
    submitted: "/submit",
    refereeLogin: "/refereeLogin",
    refereeSubmit: "/refereeSubmit",
    // for screening
    fetchCandidates:"/fetchCandidates",
    reviewDetails:"/reviewDetails",
    submitReviewResult:"/submitReviewResult",
    fetchCandidatesByUniversity:"/fetchCandidatesByUniversity",
    fetchCandidatesByAffiliation:"/fetchCandidatesByAffiliation",
    fetchCandidatesByName:"/fetchCandidatesByName",
    fetchCandidatesByLastName:"/fetchCandidatesByLastName",
    fetchCandidatesByJobID:"/fetchCandidatesByJobID",
    fetchCandidatesByEmail:"/fetchCandidatesByEmail",
    updateReviewStatus:"/updateReviewStatus",
    sendReviewInvitation:"/sendReviewInvitation",
    screenMemberLogin:"/screenMemberLogin",
    screenMemberLogout: "/cas/logout",
    ssoScreenMemeberLogout: "/sso/logout",
    currentReviewDetails:"/currentReviewDetails",
    fetchStatusTimeline:"/fetchTimeline",
    recommendForDecline:"/recommendForDecline",
    getRequestDeclineList:"/getRequestDeclineList",
    declineRecommendOperation:"/declineRecommendOperation",
    fetchAccessRight:"/fetchAccessRight",
    externalLogin:"/externalLogin",
    resetPasswordScreening:"/externalStartResetPassword",
    updatePasswordScreening:"/externalUpdatePassword",

    // for additional data
    createAdditional: "offerProcessing",
    getAdditional:"/getAdditionalData",
    updateAdditional:"/updateAdditionalData",
    submitAdditional:"/submitAdditionalData",
    offerProcessing:"/offerProcessing",
    sendDataCollection:"/sendDataCollection",

    //e check list
    fetchECheckList: "/checklist/fetch",
    fetchECheckListByUsername: "/checklist/fetchByUser",
    createECheckList: "/checklist/create",
    lockECheckList: "/checklist/lock",
    unLockECheckList: "/checklist/unlock",
    updateECheckList: "/checklist/update",
    eCheckListUploadFile: "/checklist/file-upload",
    eCheckListUploadVideo: "/checklist/video-upload",
    eCheckListDownloadFile: "/api/checklist/file",
    eCheckListDownloadVideo: "/api/checklist/video",
    eCheckListLogin: "/api/cas/loginChecklist",
    eCheckListFetchAccessRight: "/checklist/fetchAccessRight"
}
